export default function MapLoader() {
	return new Promise((resolve, reject) => {
		window._AMapSecurityConfig = {
			serviceHost: 'https://api.yibxj.com/_AMapService',
		}
		//   resolve(window.AMap)
		// } else {
		var script = document.createElement('script')
		script.type = 'text/javascript'
		script.async = true
		script.src = 'https://webapi.amap.com/maps?v=1.4.15&callback=initAMap&key=7ec99d6a26e70b482aa459f4c12e8307&plugin=AMap.PlaceSearch'
		script.onerror = reject
		document.head.appendChild(script)
		// }
		window.initAMap = () => {
			resolve(window.AMap)
		}
	})
}
/*
 * 异步创建script标签
 */
// export default function MapUILoader () {
//   const mp = new Promise((resolve, reject) => {
//     if (window.AMap) {
//       resolve(window.AMap)
//     } else {
//       var script = document.createElement('script')
//       script.type = 'text/javascript'
//       script.async = true
//       script.src = 'http://webapi.amap.com/maps?v=1.4.15&callback=initAMap&key=381f412856e6f1757c733a944b6337ba'
//       script.onerror = reject
//       document.head.appendChild(script)
//     }
//     window.initAMap = () => {
//       resolve(window.AMap)
//     }
//   })

//   const mpUI = new Promise((resolve, reject) => {
//     if (window.AMapUI) {
//       resolve(window.AMapUI)
//     } else {
//       var scriptUI = document.createElement('script')
//       scriptUI.type = 'text/javascript'
//       scriptUI.src = 'http://webapi.amap.com/ui/1.1/main.js?v=1.1.1'
//       scriptUI.onerror = reject

//       scriptUI.onload = function(su){
//         resolve(window.AMapUI)
//       };
//       document.head.appendChild(scriptUI)
//     }

//   })

//   return Promise.all([mp,mpUI])
//     .then(function (result) {
//       return result
//     }).catch(e=>{
//       console.log(e);})
// }





// WEBPACK FOOTER //
// ./src/assets/js/loadMap.js
